module.exports = __webpack_public_path__ + "img/map_test10.ab08c609.jpg";